/* The Afternoon Daydream — scent quiz.
   Ported from the Next.js ScentQuiz React component. Same four phases
   (opening → doors → scene → result), same markup, no framework. */
(function () {
  var root = document.querySelector('[data-scent-quiz]');
  if (!root) return;

  var openingEl = root.querySelector('[data-quiz-phase="opening"]');
  var stageEl = root.querySelector('[data-quiz-stage]');
  var configEl = document.querySelector('[data-quiz-config]');
  if (!stageEl || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  var L = config.labels || {};

  var data = null;
  var history = [];
  var sceneId = null;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function preload(urls) {
    urls.forEach(function (url) {
      if (!url) return;
      var img = new Image();
      img.src = url;
    });
  }

  function showStage(html) {
    if (openingEl) openingEl.hidden = true;
    stageEl.hidden = false;
    stageEl.innerHTML = html;
    var focusable = stageEl.querySelector('button, a[href]');
    if (focusable) focusable.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  function showOpening() {
    stageEl.hidden = true;
    stageEl.innerHTML = '';
    if (openingEl) openingEl.hidden = false;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  function topline() {
    return (
      '<div class="quiz-topline">' +
      '<button type="button" class="back-link" data-back>' + esc(L.back) + '</button>' +
      '<a class="quiz-exit" href="' + esc(L.exitUrl) + '">' + esc(L.exit) + '</a>' +
      '</div>'
    );
  }

  /* ---------- phase: doors ---------- */

  function renderDoors() {
    var doors = data.doors || [];
    preload(
      doors.map(function (d) {
        return config.sceneImages[d.next];
      })
    );

    var buttons = doors
      .map(function (door, i) {
        return (
          '<button type="button" class="dream-door" data-door="' + i + '" ' +
          'aria-label="' + esc(door.label + '. ' + door.description) + '">' +
          '<span class="door-number">' + pad(i + 1) + '</span>' +
          '<span class="door-label">' + esc(door.label) + '</span>' +
          '</button>'
        );
      })
      .join('');

    showStage(
      '<main class="dream-stage dream-doors">' +
        topline() +
        '<p class="progress">01 / 04</p>' +
        '<div class="door-copy">' +
          '<p>' + esc(L.doorsIntro) + '</p>' +
          '<h1>' + esc(L.doorsQuestion) + '</h1>' +
        '</div>' +
        '<div class="doors-art">' +
          '<img class="fill-img" src="' + esc(config.doorsImage) + '" alt="' + esc(L.doorsAlt) + '">' +
          '<span class="door-focus door-focus-1" aria-hidden="true"></span>' +
          '<span class="door-focus door-focus-2" aria-hidden="true"></span>' +
          '<span class="door-focus door-focus-3" aria-hidden="true"></span>' +
          '<div class="door-row" aria-label="Choose a dream door">' + buttons + '</div>' +
        '</div>' +
      '</main>'
    );
  }

  /* ---------- phase: scene ---------- */

  function renderScene(id) {
    var scene = data.scenes[id];
    if (!scene) return;
    sceneId = id;

    preload(
      scene.choices.map(function (c) {
        return c.next ? config.sceneImages[c.next] : null;
      })
    );

    var choices = scene.choices
      .map(function (choice, i) {
        return (
          '<button type="button" data-choice="' + i + '">' +
          '<span>' + pad(i + 1) + '</span>' +
          '<strong>' + esc(choice.label) + '</strong>' +
          '<i aria-hidden="true">&rarr;</i>' +
          '</button>'
        );
      })
      .join('');

    var bg = config.sceneImages[id] ? "url('" + config.sceneImages[id] + "')" : 'none';
    var mark = (data.worldMarks && data.worldMarks[scene.world]) || '';

    showStage(
      '<main class="dream-stage quiz-scene world-' + esc(scene.world) + '" style="--scene-image:' + bg + '">' +
        topline() +
        '<p class="progress">' + pad(scene.step) + ' / 04</p>' +
        '<section class="scene-composition" aria-live="polite">' +
          '<div class="scene-world-mark" aria-hidden="true"><span>' + esc(mark) + '</span></div>' +
          '<div class="scene-narrative">' +
            '<p>' + esc(scene.copy) + '</p>' +
            '<h1>' + esc(scene.question) + '</h1>' +
            '<div class="scene-choices">' + choices + '</div>' +
          '</div>' +
        '</section>' +
      '</main>'
    );
  }

  /* ---------- phase: result ---------- */

  function renderResult(id) {
    var result = data.results[id];
    if (!result) return;
    var match = (config.products && config.products[id]) || {};

    showStage(
      '<main class="quiz-result result-' + esc(id) + '">' +
        '<nav class="result-nav">' +
          '<a href="' + esc(L.exitUrl) + '">' + esc(L.wordmark) + '</a>' +
          '<span>' + esc(L.resultNavNote) + '</span>' +
        '</nav>' +
        '<section class="result-reveal" aria-live="polite">' +
          '<div class="result-personality">' +
            '<p class="result-eyebrow">' + esc(L.personalityEyebrow) + '</p>' +
            '<h1>' + esc(result.personality) + '</h1>' +
            '<strong>' + esc(result.supportingLine) + '</strong>' +
            '<p>' + esc(result.personalityCopy) + '</p>' +
          '</div>' +
          '<div class="result-product-image">' +
            '<span>' + esc(L.yourMatch) + '</span>' +
            '<img class="fill-img" src="' + esc(match.image) + '" alt="' + esc(result.productName + ' SoraKsa token incense') + '">' +
          '</div>' +
        '</section>' +
        '<section class="result-match">' +
          '<div class="result-match-title">' +
            '<p>' + esc(L.yourMatch) + '</p>' +
            '<h2>' + esc(result.productName) + '</h2>' +
          '</div>' +
          '<div class="result-scent-copy">' +
            '<p>' + esc(result.scentDescription) + '</p>' +
            '<div><span>' + esc(L.scentNotes) + '</span><strong>' + esc(result.notes) + '</strong></div>' +
            '<div><span>' + esc(L.yourRitual) + '</span><strong>' + esc(result.mood) + '</strong></div>' +
            '<a href="' + esc(match.url) + '" data-result-cta>' +
              esc(L.ctaPrefix + ' ' + result.productName) + ' <span aria-hidden="true">&rarr;</span>' +
            '</a>' +
            '<button type="button" class="dream-again" data-restart>' + esc(L.dreamAgain) + '</button>' +
            '<p class="secondary-match">' + esc(L.secondaryPrefix) + ' <strong>' + esc(result.secondary) + '</strong>.</p>' +
          '</div>' +
        '</section>' +
        '<div class="result-forest" role="img" aria-label="Sunlight passing through a redwood forest">' +
          '<span>' + esc(L.closing) + '</span>' +
        '</div>' +
      '</main>'
    );

    try {
      sessionStorage.setItem('soraksa-scent-result', id);
    } catch (e) {
      /* private browsing — the result just is not remembered */
    }
  }

  /* ---------- interaction ---------- */

  function goBack() {
    if (!sceneId) {
      showOpening();
      return;
    }
    var previous = history.pop();
    if (previous) {
      renderScene(previous);
    } else {
      sceneId = null;
      renderDoors();
    }
  }

  stageEl.addEventListener('click', function (event) {
    var el = event.target.closest('[data-door],[data-choice],[data-back],[data-restart],[data-result-cta]');
    if (!el) return;

    if (el.hasAttribute('data-back')) {
      goBack();
      return;
    }

    if (el.hasAttribute('data-restart')) {
      sceneId = null;
      history = [];
      renderDoors();
      return;
    }

    if (el.hasAttribute('data-door')) {
      var door = data.doors[Number(el.getAttribute('data-door'))];
      if (!door) return;
      emit('quiz_choice_selected', { question: 'door', world: door.tone, choice: door.label });
      history = [];
      renderScene(door.next);
      return;
    }

    if (el.hasAttribute('data-choice')) {
      var scene = data.scenes[sceneId];
      if (!scene) return;
      var choice = scene.choices[Number(el.getAttribute('data-choice'))];
      if (!choice) return;

      emit('quiz_choice_selected', { question: sceneId, world: scene.world, choice: choice.label });

      if (choice.result) {
        var done = data.results[choice.result];
        emit('quiz_completed', { personality: done.personality, product: done.productName });
        renderResult(choice.result);
        return;
      }
      if (choice.next) {
        history.push(sceneId);
        renderScene(choice.next);
      }
      return;
    }

    if (el.hasAttribute('data-result-cta')) {
      emit('quiz_product_clicked', { product: el.textContent.trim() });
    }
  });

  var startButton = root.querySelector('[data-quiz-start]');
  if (startButton) {
    startButton.addEventListener('click', function () {
      if (!data) return;
      emit('quiz_started', {});
      renderDoors();
    });
    startButton.disabled = true;
  }

  fetch(root.getAttribute('data-src'))
    .then(function (r) {
      return r.json();
    })
    .then(function (json) {
      data = json;
      if (startButton) startButton.disabled = false;
      preload([config.doorsImage]);
    })
    .catch(function () {
      if (startButton) {
        startButton.disabled = false;
        startButton.textContent = 'The daydream could not load';
      }
    });
})();
